import { observer } from "mobx-react-lite";
import { useTabPageStore } from "@/components/layout/components/tab-bar/use-tab-page-store";
import { SearchPageFloatyView } from "./search-page-floaty.view";

export const SearchPageFloaty = observer(() => {
  const page = useTabPageStore("searchPage");

  const deepSearchResultsCount = page.deepSearchResults.length;
  const selectedItemsCount = page.listState.selectedItemIds.length;
  const isShowingDeepSearchResults = page.showDeepSearchResults;

  const isVisible = selectedItemsCount === 0 && deepSearchResultsCount > 0;

  const handleToggleChange = (checked: boolean) => {
    page.setShowDeepSearchResults(checked);
  };

  return (
    <SearchPageFloatyView
      isVisible={isVisible}
      deepSearchResultsCount={deepSearchResultsCount}
      isShowingDeepSearchResults={isShowingDeepSearchResults}
      isSelected={isShowingDeepSearchResults}
      onToggleChange={handleToggleChange}
    />
  );
});
